import { Injectable } from '@angular/core';

export interface loadingNotificationInterface {
	id: number;
	text: string;
	icon: string;
	status: 'loading' | 'success' | 'error' | 'attention';
}

@Injectable({
	providedIn: 'root',
})
export class LoadingNotificationService {
	public loadingNotificationLine: loadingNotificationInterface[] = [
		// {"id":1, "icon":"faDownload", "text":"download_file_download_file_download_file_download_file_download_file_", "status":"loading"},
		// {"id":2, "icon":"", "text":"download_file_download_file_download_file_download_file_download_file_", "status":"success"},
		// {"id":2, "icon":"", "text":"download_file_download_file_download_file_download_file_download_file_", "status":"error"},
	];

	public minimize = false;

	constructor() {}

	public setNotificationMessage(
		notificationName: string,
		notificationStatus: 'loading' | 'success' | 'error' | 'attention',
		notificationIcon?: string
	): number {
		if (notificationName !== '') {
			const newId = this.loadingNotificationLine.length > 0 ? this.loadingNotificationLine.at(-1).id + 1 : 1;
			const newNotification: loadingNotificationInterface = {
				id: newId,
				text: notificationName,
				icon: notificationIcon ? notificationIcon : '',
				status: notificationStatus,
			};

			this.loadingNotificationLine.push(newNotification);
			return newNotification.id;
		}
	}

	public closeNotification(index: number): void {
		this.loadingNotificationLine.splice(index, 1);
	}

	public updateNotificationStatus(id: number, notificationStatus: 'loading' | 'success' | 'error' | 'attention'): void {
		for (let index = 0; index < this.loadingNotificationLine.length; index++) {
			const loadingNotification = this.loadingNotificationLine[index];
			if (loadingNotification.id != id) continue;
			loadingNotification.status = notificationStatus;
		}
	}

	public closeAllNotifications(): void {
		this.loadingNotificationLine = [];
	}
}
